<template>
  <div class="grid">
    <div class="header f-h f-ac m-tx4">
      <cdn-svg path="nucleo/custom-celebrations" class="h-x5 w-x5 m-rx1" />
      <div class="title t-lg bold">Celebrations</div>
    </div>
    <user-settings-celebrations class="m-tx2" />
  </div>
</template>
